// Utils
import { getCssClasses } from './renderless-composition.js';

// Spacing prop validator
const validSpacingProp = ([name, value]) => Boolean(String(value));

// Returns spacing shortcut class name based on spacing prop name
const splitSpacingPropName = ([name, value]) => {
    const [spacingName, spacingDirection] = name.split(/(?=[A-Z])/);
    const spacingShortcut = spacingName.charAt(0) + spacingDirection.toLowerCase().charAt(0);
    return [spacingShortcut, value];
};

// Match spacing prop with proper spacing class
const mapSpacingClassName = (context) => ([spacingName, spacingValue]) => getCssClasses(context)[`pcc__${spacingName + spacingValue}`];

/**
 * Map proper spacing classes based on props
 * @param {VNode} context - vNode functional component instance
 * @return {Array.<String>} - Array of proper spacing classes
 */
const getSpacingClasses = (context) => Object.entries(context.props)
    .filter(validSpacingProp)
    .map(splitSpacingPropName)
    .map(mapSpacingClassName(context));

export {
    getSpacingClasses
}